import { render, staticRenderFns } from "./DocumentationLibraryBuilder.vue?vue&type=template&id=20004e72&"
import script from "./DocumentationLibraryBuilder.vue?vue&type=script&lang=js&"
export * from "./DocumentationLibraryBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports